<script setup lang="ts">
definePageMeta({
  static: true,
  title: 'Taxa de serviço'
})

const breadcrumbData = [{
  title: 'Home',
  link: '/',
  subitems: [
    {title: 'Taxa de serviço'}
  ]
}]
</script>

<template>
  <div class="container pb-lg-4 mb-sm-2">
    <Breadcrumb :data="breadcrumbData"/>
    <div class="row">
      <PoliticsMenu activePage="service-tax"/>

      <div class="col-lg-8 col-md-7 mb-5">
        <h1 class="mb-4 pb-lg-2 h2">Taxa de serviço</h1>
        <p>A taxa de serviço {{ socialInfo.fantasyName }} é a taxa que representa a remuneração da {{ socialInfo.fantasyName }} pelo nosso trabalho por trás dos
          bastidores para possibilitar a venda do ingresso de seu evento preferido com comodidade e segurança.</p>
        <p>A remuneração na modalidade taxa de serviço cobrada diretamente do consumidor está prevista no art. 27, §2º e
          § 4º, inciso V da Lei Federal nº 11.771/08, e o STJ também já confirmou a legalidade desta cobrança sempre que
          devidamente informada ao consumidor.</p>
        <p>A {{ socialInfo.fantasyName }} tem como essência a transparência e qualidade no atendimento ao consumidor, por isso sempre que
          existir a cobrança de taxa de serviço para compra de um ingresso o valor a ser cobrado pela taxa será exibido
          em separado do valor do ingresso e de forma antecipada à compra.</p>
        <p>Se quiser mais detalhes sobre a taxa de serviço, você pode consultar o contrato de “Termos de Uso” de nosso
          site.</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
p {
  text-align: justify;
  opacity: 70;
  font-size: 14px;
}
</style>
